import ReactDOM from "react-dom";
import AppMain from "./main/AppMain";

/**
 * Let's continue to keep this file as slim as possible, serving only
 * as the app entry point and providing truly global polyfills.
 * This will facilitate writing truly isolated app slices further
 * down the tree.
 */

ReactDOM.render(<AppMain />, document.getElementById("root"));
